import type { DataSourceAbstract } from '@lighthouse/core'
import type { SendMsgDingTalkRobotConfig, VariableTree2 } from '@lighthouse/shared'
import { getInputInnerTypeMatch, NodeFieldPreview } from '@lighthouse/shared'
import React from 'react'

import * as SC from './styles'

interface LinkMsgConfigProps {
    upstreamOptions: VariableTree2[]
    userOption?: VariableTree2
    dataSourceList?: DataSourceAbstract[]
    value: SendMsgDingTalkRobotConfig
    onChange: (value: SendMsgDingTalkRobotConfig) => void
}

export const LinkMsgConfig: React.FunctionComponent<LinkMsgConfigProps> = ({
    upstreamOptions,
    userOption,
    dataSourceList,
    value,
    onChange
}) => {
    const updateLink = (patch: Partial<NonNullable<SendMsgDingTalkRobotConfig['link']>>) => {
        onChange({
            ...value,
            link: { ...(value.link || ({} as NonNullable<SendMsgDingTalkRobotConfig['link']>)), ...patch }
        })
    }

    return (
        <>
            <SC.Item>
                <SC.Text>
                    消息标题
                    <SC.Text color="red" style={{ paddingLeft: 4 }}>
                        *
                    </SC.Text>
                </SC.Text>
                {/* <AddFieldButton schema={schema} fieldIds={fieldIds} onItemClick={handleItemClick} /> */}
                <NodeFieldPreview
                    autoHeight
                    innerTypes={getInputInnerTypeMatch('TEXT')}
                    userOption={userOption}
                    upstreamOptions={upstreamOptions}
                    value={value.link?.editorTitle}
                    onBlur={editorTitle => updateLink({ editorTitle })}
                    dataSourceList={dataSourceList}
                />
            </SC.Item>
            <SC.Item>
                <SC.Text>
                    消息简介
                    <SC.Text color="red" style={{ paddingLeft: 4 }}>
                        *
                    </SC.Text>
                </SC.Text>
                <NodeFieldPreview
                    autoHeight
                    innerTypes={getInputInnerTypeMatch('TEXT')}
                    userOption={userOption}
                    upstreamOptions={upstreamOptions}
                    value={value.link?.editorText}
                    onBlur={editorText => updateLink({ editorText })}
                    dataSourceList={dataSourceList}
                />
                {/* <NodeFieldPreview autoHeight upstreamOptions={upstreamOptions} /> */}
                {/* <SC.Description>方案启动后，填入的文本内容，将被钉钉群机器人发出，请检查核对。</SC.Description> */}
            </SC.Item>
            <SC.Item>
                <SC.Text>消息缩略图</SC.Text>

                <NodeFieldPreview
                    autoHeight
                    innerTypes={getInputInnerTypeMatch('TEXT')}
                    userOption={userOption}
                    upstreamOptions={upstreamOptions}
                    value={value.link?.picUrl}
                    onBlur={picUrl => updateLink({ picUrl })}
                    dataSourceList={dataSourceList}
                />
            </SC.Item>
            <SC.Item>
                <SC.Text>
                    跳转链接
                    <SC.Text color="red" style={{ paddingLeft: 4 }}>
                        *
                    </SC.Text>
                </SC.Text>
                <NodeFieldPreview
                    autoHeight
                    innerTypes={getInputInnerTypeMatch('TEXT')}
                    userOption={userOption}
                    upstreamOptions={upstreamOptions}
                    value={value.link?.editorMessageUrl}
                    onBlur={editorMessageUrl => updateLink({ editorMessageUrl })}
                    dataSourceList={dataSourceList}
                />
            </SC.Item>
        </>
    )
}
